const {
	AJAX_TIMEOUT,
	runAjax,
	logMarketingEvent,
	onEnter,
	onClickOrEnter,
	isValidEmail,
} = require("./ElevHelpers");
const {setupModalButton} = require("./ModalUtil");
const ElevShared = require("../../../../shared/ElevShared");

const classes = Object.freeze({
	error: "ba11--input-error",
	hidden: "ba11--hidden",
	invis: "ba11--invisible",
	signupDisable: "modal-email-signup-disabled",
});
const selectors = Object.freeze({
	consent: ".modal-email-signup-checkbox",
	consentLabel: ".modal-email-signup-checkbox-label",
	emailInputs: ".mailsub-email, .ba11-email-signup-input",
	error: ".modal-email-signup-error",
	inputTab: ".modal-email-signup-email-input-tab",
	modalContinue: ".modal-email-signup-email-tab-continue",
	modalError: ".modal-email-signup-email-error",
	modalInput: ".modal-email-signup-email-input",
	roleTab: ".modal-email-signup-role-tab",
	signupRoles: ".modal-email-signup-role",
	signupSuccess: ".modal-email-signup-success",
	submit: ".modal-email-signup-continue",
	triggers: ".mailsub-btn, .ba11-email-signup-arrow-button",
});
const errorMessage = "Please enter a valid email.";
let email, modalEmailInput;

function showResponse(err, resp) {
	const error = document.querySelector(selectors.error);
	const copy = resp.error || err;

	if (copy) {
		error.innerHTML = ElevShared.copyForEmailSignupErrors(copy);
		error.classList.remove(classes.invis);
	} else {
		const roles = [...document.querySelectorAll(selectors.signupRoles)];
		const success = document.querySelector(selectors.signupSuccess);
		const submit = document.querySelector(selectors.submit);
		const label = document.querySelector(selectors.consentLabel);
		const checkbox = document.querySelector(selectors.consent);

		error.classList.add(classes.invis);
		submit.classList.add(classes.hidden);
		label.classList.add(classes.signupDisable);
		success.classList.remove(classes.hidden);

		for (const role of roles) {
			role.disabled = true;
		}
		checkbox.disabled = true;

		if (resp.success && resp.subscribed && resp.mailingListID) {
			logMarketingEvent("MailingListSignUp", resp.mailingListID);

			// Facebook Pixel and Google Ads conversion
			if (global.dataLayer) {
				global.dataLayer.push({event: "joinMailingList"});
			}
		}
	}
}

function onSubscribe(input) {
	email = input.value.trim() || modalEmailInput.value.trim();
	const consent = document.querySelector(selectors.consent);
	const error = document.querySelector(selectors.error);
	let role = "";

	const signupRoles = [...document.querySelectorAll(selectors.signupRoles)];
	for (const signupRole of signupRoles) {
		signupRole.addEventListener("click", () => {
			error.classList.add(classes.invis);
		});

		if (signupRole.checked) {
			role = signupRole.value;
		}
	}

	consent.addEventListener("click", () => error.classList.add(classes.invis));

	if (!role) {
		error.innerHTML = ElevShared.copyForEmailSignupErrors("roleNotChosen");
		error.classList.remove(classes.invis);
		return;
	}
	if (!consent.checked) {
		error.innerHTML = ElevShared.copyForEmailSignupErrors("agreeNotChecked");
		error.classList.remove(classes.invis);
		return;
	}
	return runAjax(
		{
			endpoint: "/api/mailingList/subscribe",
			timeout: AJAX_TIMEOUT,
			payload: {email, role},
		},
		showResponse
	);
}

function initModal(modal, input) {
	email = input.value.trim();
	if (email && !isValidEmail(email)) {
		return;
	}
	const submit = modal.querySelector(selectors.submit);
	if (!submit) {
		return;
	}

	onClickOrEnter(submit, () => {
		onSubscribe(input);
	});

	if (email) {
		return;
	}
	modalEmailInput = modal.querySelector(selectors.modalInput);
	const inputTab = modal.querySelector(selectors.inputTab);
	const roleTab = modal.querySelector(selectors.roleTab);
	const emailInputErrorEl = modal.querySelector(selectors.modalError);
	const modalEmailContinueButton = modal.querySelector(selectors.modalContinue);

	inputTab.classList.remove(classes.hidden);
	roleTab.classList.add(classes.hidden);

	modalEmailInput.addEventListener("keydown", e => {
		if (e.which === 13) {
			modalEmailContinueButton.click();
			return;
		}

		emailInputErrorEl.innerText = "";
	});

	onClickOrEnter(modalEmailContinueButton, () => {
		email = modalEmailInput.value;
		const notValid = !(email && isValidEmail(email));

		modalEmailInput.classList.toggle(classes.error, notValid);

		if (notValid) {
			emailInputErrorEl.innerText = errorMessage;
			return;
		}
		inputTab.classList.add(classes.hidden);
		roleTab.classList.remove(classes.hidden);
	});
}

/**
 * The email subscription form is typically located in the footer (AKA bottom
 * bar), but does occur anywhere
 */
function initSubscribe() {
	const emailInputs = [...document.querySelectorAll(selectors.emailInputs)];
	if (!emailInputs.length) {
		return;
	}

	for (const input of emailInputs) {
		let trigger = document.querySelector(input.dataset.trigger);
		if (!trigger && input.nextElementSibling.matches(selectors.triggers)) {
			trigger = input.nextElementSibling;
		}
		if (!trigger) {
			continue;
		}

		onEnter(input, () => trigger.click());
		setupModalButton(trigger, modal => {
			initModal(modal, input);
		});

		input.addEventListener("change", e => {
			email = e.target.value.trim();
			const isValid = !email || isValidEmail(email);

			trigger.setAttribute(
				"data-modal-type",
				"emailSignUp" + (isValid ? "" : "InvalidEmail")
			);
		});
	}
}

module.exports = {
	initSubscribe,
};
